import React from "react";
import VlgCheckForm from "../components/VlgCheckForm";

const VlgCheck = () => {
    return (
        <>
            <section className="flex justify-center items-center w-full min-h-screen py-10 bg-gray-100">
                <VlgCheckForm />
            </section>
        </>
    );
};

export default VlgCheck;
